/**
 * Canvas-only wrapper — lifts hover state for React Flow NodeToolbar.
 * Molecules must stay stateless; this shell lives in the KG canvas layer.
 */

import React, { useState } from "react";
import { NodeToolbar, Position } from "@xyflow/react";

import { KgCollapsedNodeHoverCard } from "../../../molecules/KgCollapsedNodeHoverCard";

export interface KgCollapsedIconShellProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  logoUrl?: string;
  logoName?: string;
}

export const KgCollapsedIconShell: React.FC<KgCollapsedIconShellProps> = ({
  children,
  title,
  subtitle,
  logoUrl,
  logoName,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      data-kg-collapsed-hover
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
      <NodeToolbar
        isVisible={isHovered}
        position={Position.Top}
        align="center"
        offset={8}
      >
        <KgCollapsedNodeHoverCard
          title={title}
          subtitle={subtitle}
          logoUrl={logoUrl}
          logoName={logoName}
        />
      </NodeToolbar>
    </div>
  );
};

export default KgCollapsedIconShell;
